import { Fragment } from "react";
import { Grid, useMediaQuery } from "@mui/material";

import type { IPaginationResult } from "@dzambalaorg/types-collection";
import { Breadcrumbs, PageHeader, ProgressOverlay } from "@dzambalaorg/mui-page-layout";
import { SearchWithFilters } from "@dzambalaorg/mui-form-search";
import { EntityInput } from "@dzambalaorg/mui-inputs-entity";
import { StyledEmptyWrapper, StyledPagination } from "@framework/styled";
import { IContract } from "@framework/types";
import { useFetchQuery } from "@dzambalaorg/react-hooks";

import { MysteryContractListItem } from "./item";
import { StyledGrid } from "./styled";

export const MysteryContractList = () => {
  const isMd = useMediaQuery(theme => theme.breakpoints.down("md"));

  const { isLoading, take, skip, onChangePage, hasNextPage, loadMoreRef, allRows, totalCount } = useFetchQuery<
    IPaginationResult<IContract>
  >("/mystery/contracts", { enableInfiniteScroll: isMd });

  return (
    <Fragment>
      <Breadcrumbs path={["dashboard", "mystery", "mystery.contracts"]} />

      <PageHeader message="pages.mystery.contracts.title" />

      <SearchWithFilters>
        <Grid container spacing={2} alignItems="flex-end">
          <Grid size={{ xs: 12 }}>
            <EntityInput name="merchantId" controller="merchants" />
          </Grid>
        </Grid>
      </SearchWithFilters>

      <ProgressOverlay isLoading={isLoading}>
        <Grid container spacing={2}>
          <StyledEmptyWrapper count={allRows.length} isLoading={isLoading}>
            {allRows.map(contract => (
              <StyledGrid size={{ lg: 4, sm: 6, xs: 12 }} key={contract.id}>
                <MysteryContractListItem contract={contract} />
              </StyledGrid>
            ))}
          </StyledEmptyWrapper>
        </Grid>
      </ProgressOverlay>

      {!isMd && totalCount > take && (
        <StyledPagination
          shape="rounded"
          page={skip / take + 1}
          count={Math.ceil(totalCount / take)}
          onChange={onChangePage}
        />
      )}
      {isMd && hasNextPage && <div ref={loadMoreRef} style={{ height: "20px", margin: "20px 0" }} />}
    </Fragment>
  );
};
